import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';

@Injectable({
  providedIn: 'root',
})
export class ParametrosService {
  url: string = `${environment.apiLocalUrl}parametros/servicios`;
  comun: string = `${environment.apiLocalUrl}comun/servicios`;
  constructor(private http: HttpClient) { }

  getActividades() {
    return this.http.get(`${this.url}/ciius`).pipe(catchError(HandleHttpError));
  }

  getPaises() {
    return this.http.get(`${this.url}/paises`).pipe(catchError(HandleHttpError));
  }

  getDepartamentos(idPais: string) {
    return this.http.get(`${this.url}/departamentos/${idPais}`).pipe(catchError(HandleHttpError));
  }

  getCiudades(idDepartamento: string) {
    return this.http.get(`${this.url}/ciudades/${idDepartamento}`).pipe(catchError(HandleHttpError));
  }

  getCiius() {
    return this.http.get(`${this.url}/ciius`).pipe(catchError(HandleHttpError));
  }
  getDocumentosApc() {
    return this.http.get(`${this.url}/tiposDocumentos/registroapc`).pipe(catchError(HandleHttpError));
  }

  getDocumentos(idSolicitud: string) {
    return this.http.get(
      `${environment.apiLocalUrl}neoSolicitudCredito/service/documentosSolicitud/${idSolicitud}`
    ).pipe(catchError(HandleHttpError));
  }

  getEstadosSolicitud() {
    return this.http.get(
      `${environment.apiLocalUrl}neoSolicitudCredito/service/estadosSolicitud`
    ).pipe(catchError(HandleHttpError));
  }

  getAnios(tipo: string) {
    return this.http.get(`${this.url}/anios/${tipo}`).pipe(catchError(HandleHttpError));
  }

  getGeneros() {
    return this.http.get(`${this.url}/genero`).pipe(catchError(HandleHttpError));
  }

  getTipoDocumentos() {
    return this.http.get(`${this.url}/tipoDocIdentidad`).pipe(catchError(HandleHttpError));
  }

  verificarCorreo(body: any) {
    return this.http.post(
      `${environment.apiLocalUrl}intermediarioFinanciero/services/verificacion`, body
    ).pipe(catchError(HandleHttpError));
  }

  activarUsuario(body: any) {
    return this.http.post(
      `${environment.apiLocalUrl}intermediarioFinanciero/services/activacion`,
      body
    ).pipe(catchError(HandleHttpError));
  }

  sendOtp(email: string) {
    return this.http.post(`${this.url}/envioOTP`, { email: email }).pipe(catchError(HandleHttpError));
  }

  getTiposNegacionDesembolso() {
    return this.http.get(`${this.url}/tiposNegacionDesembolso`).pipe(catchError(HandleHttpError));
  }

  sendMailRecordar(body: any) {
    return this.http.post(`${environment.apiLocalUrl}neoUsuario/sendCorreo`, body).pipe(catchError(HandleHttpError));
  }

  getDataFromToken(token: string) {
    return this.http.get(
      `${environment.apiLocalUrl}neoUsuario/validarToken/${token}`
    ).pipe(catchError(HandleHttpError));
  }

  refreshToken(token: string, isEmpresario: boolean) {
    return this.http.post(
      `${environment.apiLocalUrl}neoUsuario/refrescarToken`,
      { token: token, isEmpresario: isEmpresario }
    ).pipe(catchError(HandleHttpError));
  }

  setPassword(body: any) {
    return this.http.post(
      `${environment.apiLocalUrl}comun/servicios/recordarContrasenia`,
      body
    ).pipe(catchError(HandleHttpError));
  }

  validateOtp(body: any) {
    return this.http.post(
      `${environment.apiLocalUrl}comun/servicios/validarOTP`,
      body
    ).pipe(catchError(HandleHttpError));
  }

  getIndicadores() {
    return this.http.get(
      `${environment.apiLocalUrl}microempresario/servicios/home/estadisticas`
    ).pipe(catchError(HandleHttpError));
  }

  getPreguntasEncuesta() {
    return this.http.get(`${this.url}/encuestaSatisfaccion`).pipe(catchError(HandleHttpError));
  }

  registrarRespuestas(body: any) {
    return this.http.post(
      `${environment.apiLocalUrl}neoSolicitudCredito/service/registrarEncuesta`,
      body
    ).pipe(catchError(HandleHttpError));
  }

  getTipoNegacionOfertas() {
    return this.http.get(`${this.url}/tiposNegacionPropuestas`).pipe(catchError(HandleHttpError));
  }

  getLineasIF(idCliente): Observable<any> {
    return this.http.get(this.url + '/lineas/' + idCliente).pipe(catchError(HandleHttpError));
  }

  getLineasIFHabilitadas(idCliente): Observable<any> {
    return this.http.get(this.url + '/lineas/habilitadas/' + idCliente).pipe(catchError(HandleHttpError));
  }

  getPlazoLinea(idLinea): Observable<any> {
    return this.http.get(this.url + '/plazo/' + idLinea).pipe(catchError(HandleHttpError));
  }

  getPeriodosGraciaLinea(idLinea): Observable<any> {
    return this.http.get(this.url + '/periodosGracia/' + idLinea).pipe(catchError(HandleHttpError));
  }

  getTasaLinea(idLinea): Observable<any> {
    return this.http.get(this.url + '/tasaLinea/' + idLinea).pipe(catchError(HandleHttpError));
  }

  getTiposPeriodicidadLinea(idLinea): Observable<any> {
    return this.http.get(this.url + '/tiposPeriodicidad/' + idLinea).pipe(catchError(HandleHttpError));
  }

  getTiposCargo(): Observable<any> {
    return this.http.get(this.url + '/tiposCargo/').pipe(catchError(HandleHttpError));
  }
  getTiposCondicion(idCliente): Observable<any> {
    return this.http.get(this.url + '/tiposCondicion/' + idCliente).pipe(catchError(HandleHttpError));
  }

  getTiposCargoCondiciones(): Observable<any> {
    return this.http.get(this.url + '/tiposCargo/').pipe(catchError(HandleHttpError));
  }

  getModalidadesBancoldex(idUsuario, idSolicitud:any): Observable<any> {
    return this.http.get(this.url + '/modalidades/' + idUsuario+'/'+idSolicitud).pipe(catchError(HandleHttpError));
  }

  getDestinosModalidadBancoldex(idModalidad): Observable<any> {
    return this.http.get(this.url + '/destinos/' + idModalidad).pipe(catchError(HandleHttpError));
  }

  getPlazosModalidadBancoldex(modalidadXDestino) {
    let body = JSON.stringify(modalidadXDestino);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post(this.url + '/plazosBancoldex', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  getPeriodosGraciaModalidadBancoldex(modalidadXDestino) {
    let body = JSON.stringify(modalidadXDestino);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post(this.url + '/periodosGraciaBancoldex', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  getTasaModalidadBancoldex(datosTasaModalidadBancoldex) {
    let body = JSON.stringify(datosTasaModalidadBancoldex);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post(this.url + '/tasaLineaBancoldex', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  getTiposPeriodicidadModalidadBancoldex(modalidadXDestino) {
    let body = JSON.stringify(modalidadXDestino);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post(this.url + '/tiposPeriodicidadBancoldex', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  getIntermediarios(): Observable<any> {
    return this.http.get(this.url + '/intermediarios/').pipe(catchError(HandleHttpError));
  }

  getDetalleSolicitud(body: any) {
    return this.http.post(`${this.comun}/detallesSolicitud`, body).pipe(catchError(HandleHttpError));
  }

  getDocumentosForUpload(end: string, idSolicitud: string, idEmpresario: number) {
    return this.http.get(`${this.url}/tiposDocumentos/${end}/${idSolicitud}/${idEmpresario}`).pipe(catchError(HandleHttpError));
  }

  /**
   * Catálogo perfil hub: grupos + tipos (misma lógica que
   * neoGrupoTipoDocumento/servicios/tipo-documento/{tipo}).
   * Respuesta: { exitoso, data: NeoGrupoTipoDocumentoDTO[] }.
   * tipoPersona: express | natural | juridica
   */
  getTiposDocumentosPerfil(tipoPersona: string) {
    return this.http
      .get(`${this.url}/tiposDocumentos/perfil/${tipoPersona}`)
      .pipe(catchError(HandleHttpError));
  }

  /** URL firmada de imagen ejemplo (NEO_ARCHIVO_PUBLICO). */
  getUrlArchivoPublico(idArchivoPublico: number) {
    return this.http
      .get(
        `${environment.apiLocalUrl}neoArchivoPublico/servicios/obtener-url/${idArchivoPublico}`
      )
      .pipe(catchError(HandleHttpError));
  }

  /**
   * Destinos habilitados por tipoSolicitud: express | natural | juridica
   */
  getDestinosCreditoPerfil(tipoPersona: string) {
    return this.http
      .get(`${this.url}/destinosCredito/perfil/${tipoPersona}`)
      .pipe(catchError(HandleHttpError));
  }

  /** Redes sociales habilitadas (Sobre tu negocio). */
  getRedesSocialesPerfil() {
    return this.http
      .get(`${this.url}/redesSociales/perfil`)
      .pipe(catchError(HandleHttpError));
  }

  getTipoSociedad() {
    return this.http.get(`${this.url}/tiposSociedad`).pipe(catchError(HandleHttpError));
  }

  getEstadoCivil() {
    return this.http.get(`${this.url}/estadoCivil`).pipe(catchError(HandleHttpError));
  }

  getNivelEstudios() {
    return this.http.get(`${this.url}/nivelEstudios`).pipe(catchError(HandleHttpError));
  }

  getTipoVivienda() {
    return this.http.get(`${this.url}/tiposVivienda`).pipe(catchError(HandleHttpError));
  }

  envioOTPRecordarContrasena(token: string) {
    return this.http.post(`${this.comun}/envioOTPRecordarContrasena`, {
      token: token,
    }).pipe(catchError(HandleHttpError));
  }

  validacionRecordarContrasena(token: string, password: string) {
    return this.http
      .post(`${this.comun}/validacionRecordarContrasena`, {
        token: token, password: password,}).pipe(catchError(HandleHttpError)).toPromise();
  }

  logout() {
    return this.http.get(`${this.comun}/logout`);
  }

  getSucursalesBancoldex(nit:number){
    return this.http.get(
      `${this.url}/modalidades/sucursal/${nit}`
      ).pipe(catchError(HandleHttpError));
  }

  getCondicionesFinancieras() {
    return this.http.get(`${environment.apiLocalUrl}microempresario/servicios/listarCondicionesFinancieras`).pipe(catchError(HandleHttpError));
  }

  getDocumentoVideoEncuesta() {
    return this.http.get(`${this.url}/tiposDocumentos/videoEncuesta`).pipe(catchError(HandleHttpError)).pipe(catchError(HandleHttpError));
  }

  desbloquearUsuario(body: any){
    return this.http.post(`${this.comun}/desbloquearUsuario `, body).pipe(catchError(HandleHttpError));
  }

  validarDesbloqueoUsuario(body: any){
    return this.http.post(`${this.comun}/validacionRegistro `, body).pipe(catchError(HandleHttpError));
  }
}
